// Types
import { FrontChannelTypeEnum } from '@/types/types';
import { ChannelTypeEnum } from '@/types/graphql/schemaTypes';

export const Icons = {
  [FrontChannelTypeEnum.creation]: '',
  [ChannelTypeEnum.partner]: 'people',
  [ChannelTypeEnum.private]: 'lock',
  [ChannelTypeEnum.public]: 'chat',
  [ChannelTypeEnum.spam]: ''
};
